export default "__VITE_ASSET__uALT36OwjCYh1xG0CuwxPQ__";